<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Personale </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <!-- Bottone di salvataggio -->
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="creaCalendario"
            small
            v-bind="attrs"
            v-on="on"
            class="ml-5"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Crea calendario schedulazione</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtra()"
          hide-details
          :items="lista_personale"
          :item-text="(e) => e.cognome"
          item-value="des"
          label="Cognome"
          style="display: inline-block; max-width: 350px"
          v-model="cognome_filtro"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                cognome_filtro = '';
                filtra();
              "
              color="primary"
              >{{
                cognome_filtro == "" ? "mdi-filter" : "mdi-filter-off"
              }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col></v-row
    >

    <v-data-table
      height="60vh"
      style="width: 40vw; margin: auto"
      :headers="headers_personale"
      :items="lista_vista"
      fixed-header
      :key="aggiorna"
      class="elevation-1 pt-0"
    >
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            personale_sel_id = item.id_utente;
            persone.push(personale_sel_id);
          "
          small
          ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
              >mdi-calendar-star</v-icon
            ></v-btn
        >
      </template>
      <!-- Colonna della generazione calendario -->
      <template v-slot:[`item.cal_gen`]="{ item }">
        <v-btn @click="generaCalendario(item)" small
          ><v-icon :color="item.disponibilita ? 'primary' : 'orange'"
            >mdi-calendar-plus</v-icon
          ></v-btn
        >
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico
        @click_chiudi="dialog_calendario_generico = false"
        :bottoni="true"
      />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          getEccezioniLista();
        "
        :id_riferimento="personale_sel_id"
        :tipo="4"
      />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";


export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico, SnackbarQV },

  props: [],

  data() {
    return {
      // Variabili d'appoggio
      personale_sel_id: null,
      cognome_filtro: "",
      aggiorna: 0,
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,

      // Array
      headers_personale: new Array(),
      lista_personale: new Array(),
      lista_vista: new Array(),
      lista_eccezioni: new Array(),
      lista_disponibilita: new Array(),

      //Array per la creazione del calendario dello schedulatore
      persone: new Array(),
    };
  },

  computed: {},

  watch: {
    lista_personale: {
      immediate: true,
      handler() {
        this.lista_vista = this.lista_personale;
        this.filtra();
      },
    },
  },

  methods: {
    creaCalendario() {
      this.persone = this.persone.toString();
      console.log(this.persone);

      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariopersone",
          token: localStorage.getItem("user_token"),
          persone: this.persone,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.persone = [];
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    filtra() {
      console.log("filtra");

      let items_wo_tmp = [];
      this.lista_personale.forEach((elem) => {
        items_wo_tmp.push(elem);
      });

      // Filtro il cognome
      if (this.cognome_filtro != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.cognome == this.cognome_filtro) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      this.lista_vista = [];
      this.lista_vista = items_wo_tmp;
    },

    generaCalendario(item) {
      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariopersone",
          token: localStorage.getItem("user_token"),
          persone: [{ id_persona: item.id_utente }]
        }
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
            this.getPersonale();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getPersonale() {
      this.headers_personale = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        {
          text: "Genera calendario",
          value: "cal_gen",
        },
        {
          text: "Nome",
          value: "nome",
        },
        {
          text: "Cognome",
          value: "cognome",
        },
      ];

      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_personale = res.data.result.utenti
              ? res.data.result.utenti
              : [];
            this.getEccezioniLista();
            this.getDisponibilitaLista();
            console.log(this.lista_personale);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 4,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          this.lista_personale.forEach((persona) => {
            persona.eccezione = false;
            this.lista_eccezioni.forEach((ecc) => {
              if (persona.id_utente == ecc.rif_calendario) {
                console.log("trovata eccezione");
                persona.eccezione = true;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    getDisponibilitaLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getdisponibilitapersona",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_disponibilita = res.data ? res.data : [];
          this.lista_personale.forEach((persona) => {
            persona.disponibilita = true;
            this.lista_disponibilita.forEach((ecc) => {
              if (persona.id_utente == ecc.id_persona) {
                persona.disponibilita = false;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },
  },

  created() {},

  mounted() {
    this.getPersonale();
  },
};
</script>

<style scoped>
</style>